import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n/index.js"

import '../static/font/font.css'

Vue.config.productionTip = false;

import VueAwesomeSwiper from "vue-awesome-swiper"
import "swiper/css/swiper.css"
Vue.use(VueAwesomeSwiper)

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import animated from "animate.css"
Vue.use(animated)

import { Popup, Swipe, SwipeItem, Collapse, CollapseItem, Toast } from 'vant';
import 'vant/lib/popup/style';
import 'vant/lib/swipe/style';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/toast/style';
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Toast);

// 回到页面顶部
Vue.prototype.menu = function () {
  window.scrollTo(0,0);
}
// 路由跳转
Vue.prototype.goToMenu = function (link) {
  this.$router.push({ name: link });
}

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

// 滚动动画
Vue.directive("animate", {
  inserted: function (el,binding) {
    let top = el.getBoundingClientRect().top;
    if (top < window.innerHeight) {
      el.classList.remove("v_hidden")
      el.classList.add("animate__animated")
      Object.keys(binding.value).forEach((key) => {
        el.classList.add(binding.value[key])
      })
    } else {
      window.addEventListener("scroll", function(){
        top = el.getBoundingClientRect().top;
        if (top <= window.innerHeight ) {
          el.classList.remove("v_hidden")
          el.classList.add("animate__animated")
          Object.keys(binding.value).forEach((key) => {
            el.classList.add(binding.value[key])
          })
        }
      });
    }
  }
})

new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js